const LOCAL_EXCHANGE_LINKS = Object.freeze({
    binance: 'https://www.bmwweb.club/zh-CN/referral/earn-together/refer2earn-usdc/claim?hl=zh-CN&ref=GRO_28502_7ONUK&utm_source=default',
    okx: 'https://www.nocmjsdty.com/join/6CngT5?channelId=UPLUS3',
    gate: 'https://www.gateport.company/share/blgxufhy?ref_type=103',
    bybit: 'https://partner.bybit.com/b/123512'
})

const exchangeLinks = {
    ...LOCAL_EXCHANGE_LINKS
}

const EXCHANGE_KEY_BY_TYPE = Object.freeze({
    0: 'binance',
    1: 'okx',
    2: 'gate',
    3: 'bybit'
})

const EXCHANGE_KEY_BY_INDEX = ['okx', 'binance', 'gate', 'bybit']

function getLink(item) {
    if (typeof item === 'string') return item.trim()
    return item && typeof item.link === 'string' ? item.link.trim() : ''
}

export default {
    setExchangeLinks(list) {
        const result = Array.isArray(list) ? list : []
        const remoteLinks = {}

        result.forEach((item, index) => {
            const type = item && item.type !== undefined ? Number(item.type) : null
            const key = EXCHANGE_KEY_BY_TYPE[type] || EXCHANGE_KEY_BY_INDEX[index]
            if (key) remoteLinks[key] = getLink(item)
        })

        Object.keys(exchangeLinks).forEach(key => {
            exchangeLinks[key] = remoteLinks[key] || LOCAL_EXCHANGE_LINKS[key]
        })
    },

    resetExchangeLinks() {
        Object.assign(exchangeLinks, LOCAL_EXCHANGE_LINKS)
    },

    okx_address(){
        return exchangeLinks.okx
    },
    binance_address(){
        return exchangeLinks.binance
    },

    gate_address(){
        return exchangeLinks.gate
    },

    bybit_address(){
        return exchangeLinks.bybit
    },

    download_android_address(){
        return 'https://dl.uplus888.work/download/20260324100842.apk'
    },

    download_ios_h5_address(){
        return 'https://dl.uplus888.work/download/20260417.mobileconfig'
    },

    download_ios_beta_address(){
        return 'https://testflight.apple.com/join/z5P0yjyt'
    },

    download_ios_p_address(){
        return 'https://ngyzz.jjmh22.com/tq5kRENW7/14rF3Y6USDl2CSzxe'
    },

    download_ios_address(){
        // return 'https://u.ppx6.com/5aad59'
        return 'https://fyoss.fy5.co/d7mt2d'
    },

    host_uri() {
        return 'ai.uplustrade.com'
        // return 'localhost'
    }
}
